import { createSystem, defaultConfig } from '@chakra-ui/react';
import { brandThemeConfig } from '@planner/config';
import { brand } from './lib/env.js';

/** Chakra system generated from the build-time brand's tokens. */
export const system = createSystem(defaultConfig, brandThemeConfig(brand));
